import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const ClientCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.CLIENTS, "uid");